import {createSlice} from '@reduxjs/toolkit'
import {
  deleteProgram,
  getPrograms,
  getProgramsSummary
} from "@/store/program-summary/action";

const initialState = {
  state: {
    programs: [],
    summary: {
      all: 0,
      one_time: 0,
      recurring: 0
    },
    paging: {
      page: 0,
      size: 0,
      total_page: 0,
      total_size: 0
    }
  },
  loading: true,
  error: ''
} as BaseState<ProgramSummaryState>

const slice = createSlice({
  name: 'programSummarySlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPrograms.pending, (state) => ({
      ...state,
      loading: true,
      error: null
    }))
    builder.addCase(getPrograms.fulfilled, (state, action) => {
      const { items, paging } = action.payload
      return {
        state: {
          ...state.state,
          paging,
          programs: items
        },
        loading: false,
        error: null
      }
    })
    builder.addCase(getPrograms.rejected, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to get Programs'
    }))

    builder.addCase(deleteProgram.pending, (state) => ({
      ...state,
      loading: true,
      error: null
    }))
    builder.addCase(deleteProgram.fulfilled, (state) => ({
      ...state,
      loading: false,
      error: null
    }))
    builder.addCase(deleteProgram.rejected, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to delete program'
    }))
  
    builder.addCase(getProgramsSummary.pending, (state) => ({
      ...state,
      loading: true,
      error: null
    }))
    builder.addCase(getProgramsSummary.fulfilled, (state, action) => ({
      state: {
        ...state.state,
        summary: action.payload
      },
      loading: false,
      error: null
    }))
    builder.addCase(getProgramsSummary.rejected, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to get program summary'
    }))
  }
})

export default slice
